export default __webpack_public_path__ + "static/media/julia2.489ce348.jpg";